import {
	getUserInfoService,
	getRankAndViewService,
	getPlaceService,
	getTalentTyleService,
	getTradeService,
	getLocalTyleService
} from '@/service/getData'

import {
	GET_USERINFO,
	GET_PLACES,
	GET_TALENTS,
	GET_TRADE,
	GET_LOCALS
} from './mutation-types'

import common from '@/config/common';

export default {

	//获取用户信息(基本信息，认证信息，浏览信息)
	async getUserInfoAction({commit,state}){
		getRankAndViewService().then((rsp)=>{
			if(rsp.data && rsp.data.ok && !rsp.data.err && rsp.data){
				/*let rankObj = rsp.data.people || {};*/
				let userInfoObj = rsp.data.userInfo || {};
				let viewObj = rsp.data.view || {};
				let vipObj = rsp.data.vip || {};
				let userInfo = {
					/*rankObj : rankObj.info || {},*/
					userInfoObj : userInfoObj.info || {},
					viewObj : viewObj.info || {},
					vip: vipObj.info || {}
				};
				commit(GET_USERINFO, userInfo);
			}
		});
	},

	//获取城市
	getPlaceAction({commit,state}){

		//如果place有值返回
		if(state.placeObj.place.length>0){
			return;
		}

		getPlaceService().then((rsp)=>{
			if(rsp.data && rsp.data.ok && !rsp.data.err){
				let place = rsp.data.enum.place || [];
				let place_sub = rsp.data.enum.place_sub || [];
				place_sub = common.getSubDict(place_sub);
				let placeObj = {
					place,place_sub
				};
				commit(GET_PLACES, placeObj);
			}
		});
	},

	//获取人才
	getTalentAction({commit,state}){
		//如果talent有值返回
		if(state.talentArr.length>0){
			return;
		}
		getTalentTyleService().then((rsp)=>{
			if(rsp.data && rsp.data.ok && !rsp.data.err){
				let talentArr = rsp.data.list || [];
				commit(GET_TALENTS, talentArr);
			}
		});
	},

	//获取领域
	getTradeAction({commit,state}){

		//如果place有值返回
		if(state.tradeObj.trade.length>0){
			return;
		}

		getTradeService().then((rsp)=>{
			if(rsp.data && rsp.data.ok && !rsp.data.err){
				let trade = rsp.data.enum.trade || [];
				let trade_sub = rsp.data.enum.trade_sub || [];
				trade_sub = common.getSubDict(trade_sub);
				let tradeObj = {
					trade,trade_sub
				};
				commit(GET_TRADE, tradeObj);
			}
		});
	},

	//获取机构类型
	getLocalAction({commit,state}){
		//如果talent有值返回
		if(
			state.localObj.gb_hy.length || 
			state.localObj.kind.length || 
			state.localObj.place.length
		){
			return;
		}
		getLocalTyleService().then((rsp)=>{
			if(rsp.data && rsp.data.ok && !rsp.data.err){
				let localObj = rsp.data.enum || [];
				let place_sub = localObj.place_sub || [];
				localObj.place_sub = common.getSubDict(place_sub);
				commit(GET_LOCALS,localObj);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/store/action.js